import DirectoryApiModel from '../../abstracts/DirectoryApiModel';

export default class ChangePasswordRequestModel extends DirectoryApiModel {
	static get path(): string {
		return '/change_password_requests';
	}
}
